// Copyright (c) 2016 Deere & Company

export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "Une mise en page portant ce nom existe d\xE9j\xE0",
  ACCEPT: "Accepter",
  ACCEPT_ALL: "Tout accepter",
  ACCEPT_REJECT_TRANSFER_PENDING: "Approbation en attente",
  ACCEPTED: "Accept\xE9",
  ACCOUNT: "Compte",
  ACCOUNT_ADDRESS: "Adresse du concessionnaire",
  ACCOUNT_COUNTRY: "Pays de compte",
  ACCOUNT_END: "Fin de compte",
  ACCOUNT_NAME: "Nom de compte",
  ACCOUNT_NUMBER: "Num\xE9ro de compte",
  ACCOUNT_NUMBER_REQUIRED: "Num\xE9ro de compte n\xE9cessaire",
  ACCOUNTS: "Comptes",
  ACCUMULATED_DAYS_ON_RENT: "Jours accumul\xE9s en location",
  ACCUMULATED_DAYS_RENTED: "Jours accumul\xE9s de location",
  ACTIONS: "Actions",
  ACTIVE_WARRANTY: "Garantie active",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Garantie active (cliquer pour plus d\u2019informations)",
  ACTUAL_AUDIT: "Audit actuel",
  ACTUAL_AUDIT_DATE: "Date atuelle d'audit",
  ACTUAL_COURIER_NAME: "Nom r\xE9el du transporteur",
  ACTUAL_HOURS: "Heures r\xE9elles",
  ADD_CLAIM: "Ajouter une demande de garantie",
  ADD_CLAIMS: "Ajouter des demandes de garantie",
  ADD_COMPONENT: "Ajouter un composant",
  ADD_OPTION: "Ajouter une option",
  ADD_REP: "R\xE9paration additionelle",
  ADD_TO_AUDIT: "Ajouter \xE0 l\u2019audit",
  ADDITIONAL: "Suppl\xE9mentaire",
  ADDITIONAL_COMMENTS: "Commentaires additionnels",
  ADDITIONAL_REPAIR: "R\xE9paration additionelle",
  ADDITIVE: "Additif",
  ADDRESS: "Adresse",
  ADDRESS_LINE1: "Ligne d'adresse 1",
  ADDRESS_LINE1_REQUIRED: "Ligne d'adresse 1 requise",
  ADDRESS_LINE2: "Ligne d'adresse 2",
  ADJ_CLM: "Ajuster la demande de garantie",
  ADJUST_CLAIM: "Ajuster la demande de garantie",
  ADJUSTED_HOURS: "Heures ajust\xE9es",
  ADJUSTED_QUANTITY: "Quantit\xE9 r\xE9gl\xE9e",
  ADJUSTMENT_TYPE: "Type de r\xE9glage",
  ADVANCED_CLAIM_SUMMARY: "Avanc\xE9e Sommaire de la demande de garantie",
  AFTER_DELIVERY_INSPECTION: "INSPECTION APR\xC8S LIVRAISON",
  AGENCY_NAME: "Nom de l'agence",
  ALL: "Tout",
  ALL_ACCOUNTS: "Tous les comptes",
  ALL_CLAIMS: "Toutes les demandes de garantie",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "Toutes les demandes sont sujettes \xE0 examen (voir JD WAM 110,08 pour plus d'informations)",
  ALL_CLAIMS_TAB: "Toutes les demandes de garantie ({count, number})",
  ALL_PART_REQUESTS: "Toutes les demandes de retour de pi\xE8ces",
  ALL_PART_REQUESTS_WITH_COUNT: "Toutes les demandes de retour de pi\xE8ces ({count})",
  ALL_PARTS_RETURNED: "Toutes les pi\xE8ces retourn\xE9es",
  AMOUNT: "Montant",
  AMOUNT_1: "Montant 1",
  AMOUNT_2: "Montant 2",
  AMOUNT_3: "Montant 3",
  AMOUNT_OF_USE: "Nombre d'usage",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "Historique du nombre d'usage ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "Nombre d'usage est obligatoire",
  AMOUNT_OF_USE_REQUIRED: "Nombre d'usage est obligatoire",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Les unit\xE9s du nombre d'usage est obligatoire",
  AMOUNT_RECORDED: "Unit\xE9 enregistr\xE9e",
  AMOUNT_TO_BE_DEBITED: "Montant \xE0 d\xE9biter",
  APLYPIP: "Appliquer le programme (PIP)",
  APPLICATION: "Application",
  APPLICATION_IS_REQUIRED: "Application est obligatoire",
  APPLY: "Appliquer",
  APPLY_TRAVEL: "Appliquer le d\xE9placement ",
  APPROVAL_DEALER_COMMENTS: "Commentaires d'approbabtion du concessionnaire",
  APPROVAL_DETAILS: "D\xE9tails d\u2019approbation",
  APPROVAL_LEVELS: "Niveaux d\u2019approbation",
  APPROVAL_REMARKS: "Remarques d'approbation",
  APPROVAL_STATUS: "\xC9tat d'approbation",
  APPROVE: "Approuver",
  APPROVE_LABOR_RATE: "Approuver le taux de main-d\u2019\u0153uvre",
  APPROVE_MACHINE_STATUS_UPDATE: "Approuver la mise \xE0 jour du statut de la machine",
  APPROVE_PIP_CODE_REQUEST: "Approuver la demande du code du programme (PIP)",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Approuver la demande de garantie d\u2019allocation commerciale",
  APPROVED: "Approuv\xE9(e)",
  APPROVED_CORE_VALUE: "Valeur du carcasse approuv\xE9e",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "Date d\u2019approbation ne peut pas \xEAtre ant\xE9rieure \xE0 la date de configuration",
  APPROVED_DIAGNOSTIC_AMOUNT: "Montant de diagnostic approuv\xE9e",
  APPROVED_DIAGNOSTIC_HOURS: "Heures de diagnostic approuv\xE9es",
  APPROVED_IS_REQUIRED: "Le champ Approuv\xE9 est obligatoire",
  APPROVED_LABOR_ADDITIVE: "Additif de main d'oeuvre approuv\xE9e",
  APPROVED_LABOR_AMOUNT: "Main d'oeuvre approuv\xE9e",
  APPROVED_LABOR_HOURS: "Heures de travail approuv\xE9es",
  APPROVED_LABOR_TOTAL: "Total main d'oeuvre approuv\xE9e",
  APPROVED_ON_SHELF_COST: "Co\xFBt local approuv\xE9",
  APPROVED_OTHER_CREDITS: "Autres cr\xE9dits approuv\xE9s",
  APPROVED_PARTS: "Pi\xE8ces approuv\xE9es",
  APPROVED_PARTS_ADDITIVE: "Additif de Pi\xE8ces Approuv\xE9",
  APPROVED_PARTS_TOTAL: "Total de la partie approuv\xE9e",
  APPROVED_REJECTED: "Approuv\xE9(e)/Rejet\xE9(e)",
  APPROVED_REPAIR_AMOUNT: "Montant de r\xE9paration approuv\xE9",
  APPROVED_REPAIR_HOURS: "Heures de r\xE9paration approuv\xE9es",
  APPROVED_TAXES_TOTAL: "Total des taxes approuv\xE9es",
  APPROVED_TRAVEL_TOTAL: "Total de d\xE9placement-approuv\xE9",
  APPROVER: "Approbateur",
  ASCENDING: "Croissant",
  ATTACHMENTS: "Pi\xE8ces jointes",
  AUDIT_NUMBER: "Num\xE9ro d\u2019audit",
  AUDIT_PLANNED: "Audit planifi\xE9",
  AUDIT_REQUIREMENT: "Exigence de l\u2019audit",
  AUDIT_RESULTS: "R\xE9sultats de l'audit",
  AUDIT_STATUS: "\xC9tat de l\u2019audit",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Audit soumis avec succ\xE8s",
  AUDIT_SUMMARY: "R\xE9sum\xE9 de l\u2019audit",
  AUDIT_TYPE: "Type d\u2019audit",
  AUDITS: "Audits",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} audits dus",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, plural, one {audit} other {audits}} dus dans les 30 jours",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, plural, one {audit} other {audits}} en retard",
  AUTHORIZATION_NUMBER: "N\xBA d'autorization",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "Soumission automatique \xE0 partir du syst\xE8me de gestion du concessionnaire",
  AVAILABLE: "Disponible",
  AVAILABLE_COLUMNS: "Colonnes Disponibles",
  AVERAGE_DIAGNOSTICS_HOURS: "Temps moyen de diagnostic",
  AVERAGE_LUG_HEIGHT: "Hauteur moyen des crampons",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "Hauteur moyenne de crampon est obligatoire.",
  AVERAGE_REPAIR_HOURS: "Temps moyen de r\xE9paration",
  AVERAGE_REPLACEMENT_HOURS: "Temps moyen de remplacement",
  AVERAGE_TECH_PAY_RATE: "Tarif moyen de r\xE9mun\xE9ration du technicien",
  BACK: "Retour",
  BACK_TO_AUDIT: "Retour sur l\u2019audit",
  BASE_MACHINE: "Machine de base",
  BASE_MACHINE_IMPLEMENTS: "\xC9quipements de machine de base",
  BASE_MACHINE_PIN: "NIP de machine de base",
  BASIC_WARRANTY_ENDS: "Garantie de base expir\xE9e",
  BASIC_WARRANTY_ESTIMATOR: "Estimateur de garantie de base",
  BASIC_WARRANTY_STARTS: "Garantie de base commence",
  BASIS_FOR_SETTLEMENT: "Base de r\xE8glement",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Base de r\xE8glement / Commentaires d\u2019audit",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Base de r\xE8glement est obligatoire.",
  BATTERY: "Batterie",
  BEGIN_DATE: "Date du d\xE9but",
  BRANCH: "Branche",
  BUILT: "Con\xE7u(e)",
  BUSINESS_END: "Business End",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "La machine peut-elle \xEAtre remise en service ?",
  CANCEL: "Annuler",
  CERTIFIED_LETTER_SENT: "Lettre recommand\xE9e envoy\xE9e",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Changer le concessionnaire r\xE9sponsable",
  CHANGE_STATUS: "Changer le status",
  CHANGE_STATUS_FOR: "Changer le statut pour {pin}",
  CHANGED: "Modifi\xE9",
  CHANGED_BY: "Chang\xE9(e) par",
  CHANGED_ON: "Chang\xE9(e) le",
  CHINESE: "Chinois",
  CITY: "Ville",
  CITY_REQUIRED: "Ville requise",
  CLAIM: "Demande de garantie",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Claim} other {Claims}})",
  CLAIM_DEBIT: "D\xE9bit de la demande de garantie",
  CLAIM_DETAILS: "D\xE9tails de la demande de garantie",
  CLAIM_DRAFT: "\xC9BAUCHE",
  CLAIM_HISTORY: "24 mois de demandes de garantie ant\xE9rieures",
  CLAIM_HISTORY_WITH_COUNT: "24 mois de demandes de garantie ant\xE9rieures ({count})",
  CLAIM_NUMBER: "Num\xE9ro de demande de garantie",
  CLAIM_RECOVER_PERCENTAGE: "({percentage}%)",
  CLAIM_SEARCH: "Recherche de la demande",
  CLAIM_STATUS: "Statut de la demande de garantie",
  CLAIM_TYPE: "Type de d\xE9mande de garantie",
  CLAIM_TYPES: "Types de demande de garantie",
  CLAIM_UPDATED_SUCCESSFULLY: "Demande de garantie mise \xE0 jour avec succ\xE8s",
  CLAIM_VALUE: "Valeur de la demande de garantie",
  CLAIM_VALUE_DETAILS: "D\xE9tails de la valeur de demande de garantie",
  CLAIM_WITH_NUMBER: "Demande de garantie {claimNumber}",
  CLAIMS: "Demandes de garantie",
  CLAIMS_IN_PROGRESS: "Demandes de garantie en cours",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "Demandes en cours ({count})",
  CLAIMS_OVERVIEW: "Aper\xE7u des demandes de garantie",
  CLAIMS_OVERVIEW_TAB: "Aper\xE7u des demandes de garantie ({count})",
  CLAIMS_WITH_COUNT: "{count} demandes de garantie",
  CLICK_FOR_DETAILS: "(Cliquez ici pour les d\xE9tails)",
  CLICK_TO_VIEW_ALL: "Cliquer pour tout afficher",
  CLOSE: "Fermer",
  CLOSED_PART_REQUESTS: "Demandes de pi\xE8ces ferm\xE9es",
  CLOSING: "Fermeture",
  CLOSING_ACCOUNT: "Compte de cl\xF4ture",
  CLOSING_ACCOUNT_WITH_COUNT: "Cl\xF4ture du compte ({count})",
  CODE: "Code",
  COLLAPSE_ALL: "R\xE9duire tout",
  COMMENT: "Commentaire",
  COMMENTS: "Commentaires",
  COMMENTS_IS_REQUIRED: "Commentaires obligatoires",
  COMMENTS_TO_DEALER: "Comments au concessionnaire",
  COMMON_LABOR_TYPES_WARNING: "Tous les types de main-d'oeuvre ne sont pas disponibles pour les comptes s\xE9lectionn\xE9s",
  COMPANY: "Entreprise",
  COMPANY_CONTRIBUTION: "Contribution de la Compagnie",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "Contribution de la compagnie est obligatoire",
  COMPLAINT_CAUSE: "Quel \xE9tait la cause de la plainte?",
  COMPLAINT_CAUSE_IS_REQUIRED: "Cause de la plainte est obligatoire",
  COMPLAINT_CORRECTION: "Comment la plainte a \xE9t\xE9 r\xE9solue?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "Correction de la plainte est obligatoire",
  COMPLETE: "Termin\xE9",
  COMPLETED: "Termin\xE9(e)",
  COMPLETED_BY: "Termin\xE9(e) par",
  COMPLETED_DATE: "Date d'ach\xE8vement",
  COMPLETED_IN_LAST_24_MONTHS: "Termin\xE9 dans les 24 derniers mois",
  COMPLETION_STATUS: "\xC9tat d\u2019ach\xE8vement",
  COMPONENT: "Composant",
  COMPONENT_CODE: "Code du Composant",
  COMPONENT_CREATED_SUCCESSFULLY: "Consosant cr\xE9\xE9 avec succ\xE8s",
  COMPONENT_DELETED_SUCCESSFULLY: "Composant suprim\xE9 avec succes",
  COMPONENT_SERIAL_NUMBER: "Num\xE9ro de s\xE9rie du composant",
  COMPONENT_SUCCESSFULLY_UPDATED: "Mise \xE0 jour r\xE9ussie du composant",
  COMPONENTS: "Composants",
  CONFIRM: "Confirmer",
  CONFIRM_ADDITIONAL_REPAIR: "\xCAtes-vous s\xFBr de vouloir ajouter une r\xE9paration suppl\xE9mentaire?",
  CONFIRM_ADJUST_CLAIM: "\xCAtes-vous s\xFBr de vouloir modifier cette demande de garantie?",
  CONFIRM_CLOSING_ACCOUNT: "Voulez-vous vraiment accepter ce transfert?",
  CONFIRM_COPY_CLAIM: "\xCAtes-vous s\xFBr de vouloir copier cette demande de garantie?",
  CONFIRM_DELETE_ATTACHMENT: "\xCAtes-vous s\xFBr de vouloir supprimer le fichier joint?",
  CONFIRM_DELETE_CLAIM: "\xCAtes-vous s\xFBr de vouloir supprimer cette demande de garantie?",
  CONFIRM_DELETE_REGISTRATION: "\xCAtes-vous s\xFBr de vouloir supprimer cet enregistrement?",
  CONFIRM_EDIT_CLAIM: "\xCAtes-vous s\xFBr de vouloir modifier cette revendication?",
  CONFIRM_RECONCILE_CLAIM: "\xCAtes-vous s\xFBr de vouloir r\xE9soudre cette r\xE9clamation?",
  CONFIRM_RESEND_XML: "Voulez-vous vraiment renvoyer XML ? Veuillez pr\xE9voir de 24 \xE0 48 heures pour qu'il soit visible.",
  CONFIRM_SKIP_AUDIT: "\xCAtes-vous s\xFBr de vouloir ignorer cet audit?",
  CONFIRM_UNDO_REGISTRATION: "Voulez-vous vraiment annuler cet enregistrement?",
  CONTACTED: "Contact\xE9(e)",
  CONTAINS: "Contient",
  CONTRACT_NUMBER: "Num\xE9ro du contrat",
  CONTRACT_PURCHASED: "Contrat achet\xE9",
  CONTRACT_TYPE: "Type de contrat",
  COPY_CLAIM: "Copier la demande de garantie",
  CORE: "Carcasse",
  CORE_VALUE: "Valeur de la carcasse",
  COUNTRY: "Pays",
  COUNTRY_REQUIRED: "Pays requis",
  COURIER_ACCOUNT_NUMBER: "Num\xE9ro de compte de transporteur",
  COURIER_NAME: "Nom du transporteur",
  COVERAGE_DECISION: "D\xE9cision de couverture",
  COVERAGE_TYPE: "Type de couverture",
  CRDMEM: "Num\xE9ro de cr\xE9dit",
  CREATE: "Cr\xE9er",
  CREATE_CLAIM: "Cr\xE9er une demande de garantie",
  CREATE_LAYOUT: "Cr\xE9er Mise en Page",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Avant de pouvoir soumettre une demande pour ce produit, vous devez nous fournir plus d\u2019informations sur ce produit",
  CREATE_PIP_CLAIM: "Cr\xE9er une demande de garantie du programme (PIP)",
  CREATE_PIP_CLAIMS: "Cr\xE9er des demandes de garantie du programme (PIP)",
  CREATE_PRODUCT_RECORD: "Cr\xE9er un record du produit",
  CREATE_REQUEST: "Cr\xE9er une demande",
  CREATE_TRANSFER_PENDING: "Transfert en attente",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Cr\xE9er Service de transfert non disponible",
  CREATED: "Cr\xE9\xE9(e)",
  CREATED_BY: "Cr\xE9\xE9(e) par",
  CREATED_DATE: "Date de cr\xE9ation",
  CREATED_ON: "Cr\xE9\xE9(e) le",
  CREATION_DATE: "Date de cr\xE9ation",
  CREDIT_MEMO: "Note de cr\xE9dit",
  CREDIT_MEMO_DATE: "Date de note de cr\xE9dit",
  CREDIT_MEMO_ISSUE_DATE: "Note de cr\xE9dit \xE9mise",
  CREDIT_MEMO_NUMBER: "Num\xE9ro de note de cr\xE9dit",
  CREDIT_MEMO_PROCESS_DATE: "Note de cr\xE9dit trait\xE9e",
  CREDIT_MEMO_SELECTED: "Note de cr\xE9dit s\xE9lectionn\xE9e",
  CREDIT_MEMOS: "Notes de cr\xE9dit",
  CRITERIA: "Crit\xE8re",
  CRT: "Cr\xE9er",
  CSV_SEPARATOR: "S\xE9parateur CSV",
  CURRENCY: "Devise",
  CURRENT: "Actuellement",
  CURRENT_ACCOUNT: "Compte actuel",
  CURRENT_AMOUNT_OF_USE: "Nombre d'usage actuel",
  CURRENT_CUSTOMER: "Client actuel",
  CURRENT_DEALER: "Concessionnaire actuel",
  CURRENT_DEALER_DISTANCE: "Distance actuelle du concessionnaire",
  CURRENT_DEALER_LAST_SERVICE_DATE: "Date du dernier service du concessionnaire actuel",
  CURRENT_DEALER_LOCATION: "Localisation actuel du concessionnaire",
  CURRENT_HOURS: "Heures actuelles",
  CURRENT_QUANTITY: "Quantit\xE9 actuelle",
  CURRENT_RESPONSIBLE_DEALER: "Vendeur responsable actuel",
  CURRENT_VALUES: "Valeurs actuelles",
  CURRENTLY_ON_RENT: "En location",
  CUSTOM_RANGE: "Intervalle personnalis\xE9",
  CUSTOM_VALUES: "Valeurs personnalis\xE9es",
  CUSTOMER: "Client(e)",
  CUSTOMER_CONTRIBUTION: "Contribution du client",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "Contribution du client est obligatoire",
  CUSTOMER_CREATED_SUCCESSFULLY: "Client cr\xE9\xE9 avec succ\xE8s",
  CUSTOMER_DETAILS: "D\xE9tails du client",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "D\xE9tails du client mis \xE0 jour avec succ\xE8s",
  CUSTOMER_INFORMATION: "Informations client",
  CUSTOMER_INFORMATION_IS_REQUIRED: "Les informations client sont obligatoires.",
  CUSTOMER_INVALID: "Client ne peut \xEAtre cr\xE9\xE9 ou trouv\xE9, rechercher un client",
  CUSTOMER_NAME: "Nom du client",
  CUSTOMER_NAME_IS_REQUIRED: "Les informations client sont obligatoires.",
  CUSTOMER_NOT_FOUND: "Client introuvable",
  CUSTOMER_PROFILE: "Profil du client",
  CUSTOMER_REQUIRED: "Client obligatoire",
  CUSTOMER_RESOLUTION: "R\xE9solution du client",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "R\xE9solution du client est obligatoire",
  CUSTOMER_SEARCH: "Recherche du client",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Mise \xE0 jour du client r\xE9ussie",
  DAMAGED_MACHINES_HELP_TEXT: "Dans le cas d\u2019une machine endommag\xE9e, la garantie sera automatiquement suspendue jusqu\u2019\xE0 examen du pr\xE9sent formulaire par le TCSM et approbation du r\xE9tablissement de la garantie. Les machines endommag\xE9es peuvent faire l\u2019objet uniquement de ces PIP : obligatoire et S\xE9curit\xE9 obligatoire .",
  DATE: "Date",
  DATE_FORMAT: "Format de date",
  DATE_ISSUED: "Date \xE9mise",
  DATE_OF_CERTIFIED_LETTER: "Date de la lettre certifi\xE9e",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Date de l\u2019endommagement",
  DATE_OF_LAST_PERSONAL_CONTACT: "Date du dernier contact personel",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Date d'exp\xE9dition de Demande de Retour de Pi\xE8ce",
  DATE_REFUSED: "Date de refus",
  DATE_SUBMITTED: "Date de soumission",
  DAYS_FROM_REGISTRATION: "Jours depuis l\u2019enregistrement",
  DAYS_LEFT: "Jours restants",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {jour restant} other {jours restants}}",
  DAYS_ON_RENT: "Jours lou\xE9s",
  DAYS_REMAINING: "Jours restants",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {jour restant} other {jours restants}}",
  DAYS_TO_DISPLAY: "Jours \xE0 afficher",
  DBS: "DBS",
  DEALER: "Concessionnaire",
  DEALER_ACCOUNT: "Compte du concessionnaire",
  DEALER_ACCOUNT_IS_REQUIRED: "Compte du concessionnaire est obligatoire",
  DEALER_ACCOUNTS: "Comptes du concessionnaire",
  DEALER_CITY: "Ville du concessionaire",
  DEALER_COMMENTS: "Commentaires du concessionnaire",
  DEALER_CONTRIBUTION: "Contribution du concessionnaire",
  DEALER_CONTRIBUTION_IS_REQUIRED: "Contribution du concessionnaire est obligatoire",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({industryIndicator})",
  DEALER_INVOICE_NUMBER: "Num\xE9ro de facture du concessionnaire",
  DEALER_INVOICE_UPDATED: "Facture du concessionnaire est mise \xE0 jour",
  DEALER_INVOICE_UPDATES: "Facture de concessionnaire",
  DEALER_INVOICES: "Factures de concessionnaire",
  DEALER_LOCATION: "Localisation du concessionnaire",
  DEALER_LOCATION_FILTER: "Trier les localisations",
  DEALER_LOCATION_IS_REQUIRED: "Localisation du concessionnaire est obligatoire",
  DEALER_LOCATIONS: "Localisations du concessionnaire",
  DEALER_NAME: "Nom du concessionaire",
  DEALER_PHONE: "Num\xE9ro de t\xE9l\xE9phone concessionnaire",
  DEALER_POSTAL_CODE: "Code postal",
  DEALER_RECOMMENDATIONS: "Recommandations du concessionnaire",
  DEALER_RECOMMENDATIONS_TAB: "Recommandations du concessionnaire ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "R\xE9examen du revendeur r\xE9ussi",
  DEALER_SEARCH: "Rechercher un concessionnaire",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Saisir un nom, une ville ou un compte pour la recherche d\u2019un concessionnaire",
  DEALER_STATE: "Province du concessionaire",
  DEALER_SUBMISSION_WITH_CURRENCY: "Soumission du concessionnaire ({currency})",
  DEALER_TRANSFER_HISTORY: "L'historique de transfert de concessionnaire",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "Demande de transfert de revendeur en file d'attente r\xE9ussie",
  DEALER_WARRANTY: "Garantie du concessionnaire",
  DEALERS: "Concessionnaires",
  DEALERSHIP: "Concession",
  DEBIT: "D\xE9bit",
  DEBIT_AMOUNT: "Montant du d\xE9bit",
  DEBIT_FOR_CLAIM_NUMBER: "D\xE9bit pour {claimNumber}",
  DEBIT_REQUIRED: "Debit est obligatoire",
  DEBIT_REQUIRED_STATUS: "Statut du D\xE9bit est obligatoire",
  DEBIT_SUBMITTED_SUCCESSFULLY: "D\xE9bit  soumis avec succ\xE8s",
  DEBIT_TYPE: "Type de d\xE9bit",
  DEBITED: "D\xE9bit\xE9",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "Les d\xE9bits de cette demande de garantie doivent \xEAtre complet\xE9s manuellement",
  DECIMAL_FORMAT: "Format d\xE9cimal",
  DECISION_UPDATED: "D\xE9cision mise \xE0 jour",
  DECLINE: "Refuser",
  DEDUCTIBLE: "Franchise",
  DEERE_REMARKS: "Remarques de John Deere",
  DEFAULT_WARRANTY: "Garantie par d\xE9faut",
  DEL: "Supprimer",
  DELETE: "Supprimer",
  DELETE_ATTACHMENT: "Supprimer le fichier joint",
  DELETE_CLAIM: "Supprimer la demande de garantie",
  DELETE_REGISTRATION: "Supprimer l\u2019enregistrement",
  DELETE_REGISTRATION_SUCCESS: "L\u2019enregistrement a \xE9t\xE9 supprim\xE9 avec succ\xE8s",
  DELETED: "Supprim\xE9(e)",
  DELETED_BY: "Supprim\xE9(e) By",
  DELIVERED: "Livr\xE9(e)",
  DELIVERED_IS_REQUIRED: "Livr\xE9(e) est obligatoire",
  DELIVERY_DATE: "Date de livraison",
  DELIVERY_DATE_REQUIRED: "Date de livraison est requise",
  DELIVERY_DATES: "Date de livraison",
  DELIVERY_NO_DOCUMENTS: "Livraison, aucun record",
  DEMO_RENTAL_BEGIN_DATE: "Date du d\xE9but de la d\xE9monstration/ location",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "S\xE9lectionner les concessionnaires et le statut",
  DEMO_RENTAL_END_DATE: "Date de la fin de la D\xE9monstration/Location ",
  DEMO_RENTAL_HISTORY: "Historique de location",
  DENY: "Refuser",
  DENY_MACHINE_STATUS_UPDATE: "Refuser la mise \xE0 jour de l\u2019\xE9tat de la machine",
  DENY_PIP_CODE_REQUEST: "Refuser la requ\xEAte de code du programme (PIP)",
  DESCENDING: "D\xE9croissant",
  DESCRIPTION: "Description",
  DESCRIPTION_OF_DAMAGE: "Description de l\u2019endommagement",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Description de l\u2019\xE9v\xE9nement ayant entra\xEEn\xE9 l\u2019endommagement",
  DESELECT_ALL: "Tout d\xE9s\xE9lectionner",
  DETAILS: "D\xE9tails",
  DIAGNOSTICS_COVERED: "Diagnostics couvert",
  DIS_VSR: "Afficher les messages",
  DISPLAY: "Afficher",
  DISPLAY_CLAIM: "Afficher la demande",
  DISPLAY_CREDIT_MEMO: "Afficher la note de cr\xE9dit",
  DISPLAY_FORMAT: "Format d\u2019affichage",
  DISPLAY_PRODUCT: "Afficher le produit",
  DISPLAY_TAG: "Afficher l'\xE9tiquette",
  DISTANCE: "Distance",
  DISTANCE_FROM_CURRENT_DEALER: "Distance du concessionnaire actuel",
  DISTANCE_FROM_POTENTIAL_DEALER: "Distance du concessionnaire potentiel",
  DIVISION: "Division",
  DIVISION_SUMMARY: "R\xE9sum\xE9 de la division",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "Voulez-vous sauvegarder les modifications?",
  DOES_NOT_CONTAIN: "Ne contient pas",
  DOWNLOAD_TO_EXCEL: "T\xE9l\xE9charger vers Excel",
  DOWNTIME: "Temps d'immobilisation",
  DOWNTIME_IS_REQUIRED: "Temps d'immobilisation requis",
  DRAFT: "Enregistrer comme brouillon",
  DTAC_CASE: "Cas DTAC",
  DTAC_CASE_NUMBER: "Num\xE9ro de cas DTAC",
  DTAC_SOLUTION: "Solution DTAC",
  DUE_DATE: "Date d\u2019\xE9ch\xE9ance",
  DUE_WITHIN_3_MONTHS: "\xC9ch\xE9ance dans les 3 mois",
  DUPLICATE_PIN_PLATE: "Plaque NIP dupliqu\xE9e",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "Demande de plaque NIP en double mise \xE0 jour",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "Demande de plaque NIP dupliqu\xE9e cr\xE9\xE9e avec succ\xE8s",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "Demande de plaque NIP en double ({count})",
  EDIT: "Modifier",
  EDIT_CUSTOMER: "Modifier le client",
  EDIT_LAYOUT: "Modifier Mise en Page",
  EDIT_WITH_PARENTHESES: "(Modifier)",
  EFFECTIVE: "Effective",
  EFFECTIVE_DATE: "Date d\u2019application",
  EMAIL: "Courier \xE9lectronique",
  EMISSIONS_PART_SEARCH: "Recherche de pi\xE8ce d'antipollution",
  END_DATE: "Date de fin",
  END_USE: "Fin d\u2019utilisation",
  END_USE_CODE: "Code d'utilisation",
  END_USE_CODE_REQUIRED: "Code de fin d\u2019utilisation obligatoire",
  ENDS_WITH: "Termine par",
  ENGLISH: "Anglais",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Saisir un chiffre entre 0 et 1000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Saisir un chiffre entre e 0 et 10000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Saisir un chiffre entre 1 et 9999",
  ENTER_A_PART_NUMBER: "Saisissez le num\xE9ro de pi\xE8ce.",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Saisir des commentaires avant d\u2019accepter",
  EQUALS: "\xC9gal",
  ERROR: "ERREUR:",
  ERROR_MESSAGE_TITLE: "Une erreur s\u2019est produite",
  ERROR_MESSAGES: "Messages d'erreur",
  ERROR_MESSAGES_TITLE: "Plusieurs erreurs sont produites:",
  ERROR_NETWORK_ISSUES: "Une erreur de r\xE9seau a prevenu certaines donn\xE9es d'\xEAtre charg\xE9es. Veuillez essayer \xE0 nouveau.",
  ERROR_NO_DATA_TO_EXPORT: "Aucune donn\xE9e \xE0 exporter",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "Erreur lors de la r\xE9cup\xE9ration des informations client",
  ERROR_SAP: "Impossible de se connecter au serveur. Si le probl\xE8me persiste, cliquez sur le lien Nous contacter, pour une assistance \xE0 r\xE9soudre votre probl\xE8me.",
  ERROR_SESSION: "Votre session a expir\xE9.  Actualisez la page pour vous reconnecter.",
  ERROR_UNHANDLED: "Le syst\xE8me a rencontr\xE9 une erreur inattendue. Si le probl\xE8me persiste, utilisez notre fonctionnalit\xE9 Aide ou cliquez sur le lien Nous contacter, pour une assistance \xE0 r\xE9soudre votre probl\xE8me.",
  ERROR_UPLOADING_FILE: "Le fichier n\u2019\xE9tait pas ajout\xE9.",
  ESTIMATED_BASIC_DATE: "Date d'estim\xE9e de la base",
  ESTIMATED_BASIC_DAYS: "Jours estim\xE9s de la base",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Les estimations peuvent ne pas refl\xE9ter le statut de d\xE9monstration ou les heures d'utilisation non encore rapport\xE9es",
  EXCEEDS_DEMO_THRESHOLD: "D\xE9passe le seuil de la d\xE9monstration",
  EXCHANGE_RATE: "Taux d'\xE9change",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Les codes confidentiels exclus ne sont pas inclus dans ce rapport.",
  EXECUTE: "Ex\xE9cuter",
  EXPAND_ALL: "Afficher tout",
  EXPECTED_FIRST_USE: "Premi\xE8re utilisation pr\xE9vue",
  EXPIRATION_DATE: "Date d'expiration",
  EXPIRED: "Expir\xE9(e)",
  EXPIRED_PART_REQUESTS: "Demandes de pi\xE8ces expir\xE9es",
  EXPIRED_PIPS: "Programmes expir\xE9s",
  EXPIRES: "Expir\xE9",
  EXPIRING_SOON: "Expire sous peu",
  EXPORT: "Exporter",
  EXTENDED_WARRANTY: "Extension de garantie",
  FACTORY: "USINE",
  FACTORY_NAME: "Nom d'usine",
  FAILED: "\xC9chou\xE9(e)",
  FAILED_AREA: "Zone de panne",
  FAILED_AREA_IS_REQUIRED: "Zone de panne est obligatoire",
  FAILED_DATE: "Date de panne",
  FAILED_DATE_IS_REQUIRED: "Date de panne est obligatoire",
  FAILED_MODE: "Mode de panne",
  FAILED_MODE_COMMENTS: "Commentaires sur le mode de panne",
  FAILED_PART: "Pi\xE8ce d\xE9fectueuse",
  FAILED_PART_DESCRIPTION: "Description de pi\xE8ce d\xE9fectueuse",
  FAILED_PART_IS_A_REMAN_PART: "Pi\xE8ce d\xE9fectueuse est une pi\xE8ce ReMan",
  FAILED_PART_IS_REQUIRED: "Pi\xE8ce d\xE9fectueuse est obligatoire",
  FAILED_PART_SERIAL: "N\xB0 serie de la pi\xE8ce d\xE9fectueuse",
  FAILED_PART_SERIAL_IS_REQUIRED: "N\xB0 de pi\xE8ce d\xE9fectueuse est obligatoire",
  FAILURE_DATE: "Date de panne",
  FAILURE_INFORMATION: "Informations sur la panne",
  FAILURE_MODE: "Mode de d\xE9faillance",
  FAILURE_MODE_IS_REQUIRED: "Mode de panne est obligatoire",
  FAILURE_PART: "Pi\xE8ce d\xE9fectueuse",
  FAILURE_PART_DESCRIPTION: "D\xE9scription de pi\xE8ce en panne",
  FAILURE_PART_IS_REQUIRED: "Pi\xE8ce d\xE9fectueuse est obligatoire",
  FAILURE_TO_RETURN_PARTS_WARNING: "Le non-retour des pi\xE8ces demand\xE9es peut entra\xEEner un d\xE9bit.",
  FAVORITES: "Favoris",
  FILE_NAME: "Nom du fichier",
  FILE_SIZE_IS_TOO_BIG: "Taille du fichier trop grande (taille maximale 100Mo)",
  FILE_SIZE_IS_TOO_BIG_CSV: "Taille du fichier trop grande (taille maximale 1Mo)",
  FILE_UPLOAD_MESSAGE: "D\xE9poser des fichiers ici ou cliquer pour ajouter des fichiers (taille maximale: 100Mo)",
  FILE_UPLOAD_MESSAGE_CSV: "D\xE9poser des fichiers ici ou cliquer pour ajouter des fichiers (taille maximale: 1Mo)",
  FILE_UPLOAD_MESSAGE_IMAGE: "D\xE9posez des images ici ou cliquez pour ajouter des images (taille maximale: 100Mo)",
  FILE_UPLOAD_MESSAGE_SINGLE: "D\xE9poser un fichier ici ou Cliquer pour ajouter (Taille maximum 100Mo)",
  FILE_UPLOAD_UNABLE_TO_READ: "Le syst\xE8me n'a pas pu lire votre fichier.  Comparer avec le mod\xE8le et r\xE9essayer.",
  FILES: "Fichiers",
  FILTER_PLACEHOLDER: "Trier les r\xE9sultats",
  FILTER_WITH_ELLIPSIS: "Filtrer",
  FILTERED_BY_COLUMN_ID: "Tri\xE9 par {columnId}",
  FIND_CUSTOMER: "Trouver un client",
  FINNISH: "Finnois",
  FIRST_MAINTENANCE: "PREMIER ENTRETIEN",
  FIRST_NAME: "Pr\xE9nom",
  FIRST_NAME_IS_REQUIRED: "Pr\xE9nom obligatoire",
  FIRST_SHIP_TO_LOCATION: "Premi\xE8re exp\xE9dition sur site",
  FIRST_USE: "Premi\xE8re utilisation",
  FISCAL_YEAR: "Ann\xE9e fiscal",
  FLUID_SAMPLING_REQUIRED: "\xC9chantillon de fluide requis",
  FORWARDED: "Transf\xE9r\xE9(e)",
  FRENCH: "Fran\xE7ais",
  FROM: "De",
  FRWRD: "Transf\xE9rer",
  FULL_DEBIT: "D\xE9bit complet",
  GENERAL: "G\xE9n\xE9ral",
  GERMAN: "Allemand",
  GET_MAINTENANCE_PLANS: "Obtenir les programmes d\u2019entretien",
  GOODS_INSTALLATION_VAT: "TVA d\u2019installation",
  GRACE_PERIOD: "P\xE9riode de Gr\xE2ce",
  GREATER_THAN: "Sup\xE9rieur \xE0",
  GREATER_THAN_OR_EQUALS: "Sup\xE9rieur ou \xE9gal \xE0",
  GROUP_COMPLETE: "Groupe termin\xE9",
  GST_PERCENTAGE: "GST Pourcentage",
  HISTORY_TO_DISPLAY: "Historique \xE0 afficher (jours)",
  HOME: "Accueil",
  HOUR_LIMIT: "Heure limite",
  HOURS: "Heures",
  HOURS_ON_RENT: "Heures de location",
  HSN_SAC_CODE: "HSN/SAC Code",
  IGST: "IGST",
  IMPLEMENTS: "\xC9quipements",
  IN_RANGE: "Dans l'intervalle",
  INCENTIVE: "Motivation",
  INCENTIVE_PROGRAMS: "Programmes incitatifs",
  INCLUDE_FULLY_COMPLETE: "Inclure des PIP complets",
  INDICATES_REQUIRED_FIELD: "Indique un champ obligatoire",
  INFO_MESSAGE_TITLE: "Une notification du syst\xE8me a \xE9t\xE9 envoy\xE9e",
  INFO_MESSAGES: "Messages d\u2019information",
  INFO_MESSAGES_TITLE: "Plusieurs notifications du syst\xE8me ont \xE9t\xE9 envoy\xE9es",
  INFO_REQUEST_STATUS_ERROR: "L'information est pr\xEAte \xE0 \xEAtre soumise avec cette application.",
  INFORMATION: "Information",
  INFORMATION_REQUEST: "Demande d'information",
  INFORMATION_REQUEST_STATUS: "Statut de la demande d'information",
  INPUT_PIN: "Saisir le NIP",
  INSPECTION: "Inspection",
  INSTALLED_BY: "Install\xE9(e) Par",
  INSTALLED_BY_IS_REQUIRED: "Install\xE9(e) Par est obligatoire",
  INTERNAL_DEERE_COMMENTS: "Commentaires internes de Deere",
  INTERVAL_BEGINS: "Commencement de l'internvalle",
  INTERVAL_ENDS: "Fin de l\u2019intervalle",
  INTERVAL_TYPE_DESCRIPTION: "Description du type d\u2019intervalle",
  INVOICE_ACCOUNT: "Compte de facturation",
  INVOICE_DEALER: "Concessionnaire factur\xE9",
  INVOICE_NUMBER: "Num\xE9ro de facture",
  INVOICE_REQUEST: "Demande de facture",
  INVOICE_SENT: "Facture envoy\xE9e",
  INVOICE_UPDATED_SUCCESSFULLY: "Fatura mis \xE0 jour avec succ\xE9s",
  INVOICED: "Factur\xE9(e)",
  INVOICED_TO: "Factur\xE9(e) \xE0",
  IRC_PIN_MESSAGE: "Le client est un IRC & a droit \xE0 des frais de d\xE9placement et kilom\xE9trage gratuits pour les 500 premi\xE8res heures ou 12 mois de propri\xE9t\xE9 de la machine.",
  ISSUED: "\xC9mis(e)",
  ITALIAN: "Italien",
  ITEM: "Article",
  ITEM_NUMBER: "Num\xE9ro du mat\xE9riel",
  ITEM_NUMBER_IS_REQUIRED: "Num\xE9ro du mat\xE9riel obligatoire",
  JDLINK_EXPIRES: "JDLink expire",
  JDP_COMMENTS: "Commentaires de JDP",
  JDP_COMMENTS_IS_REQUIRED: "Commentaires JDP est obligatoire",
  JDP_CUSTOMER_RESOLUTION: "R\xE9solution du client JDP",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "R\xE9solution de client JDP est obligatoire",
  JDP_REASON: "Raison de JDP",
  JDP_REASON_IS_REQUIRED: "Raison JDP est obligatoire",
  LABOR: "Main d'\u0153uvre",
  LABOR_ADDITIVE: "Additif de main d'\u0153uvre",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "D\xE9tails d'ach\xE8vement de l'additif de main d'\u0153uvre",
  LABOR_ADDITIVE_PIPS: "Additif de main d'\u0153uvre des Programmes (PIP)",
  LABOR_ADDITIVE_TAB: "Additif de main d'\u0153uvre ({count})",
  LABOR_ADJUSTMENT: "R\xE9glage de la main-d'oeuvre",
  LABOR_COMMENTS: "Commentaires de Main d'\u0153uvre",
  LABOR_HOURS: "Main d'\u0153uvre",
  LABOR_ITEM_DETAILS: "Main d\u2019\u0153uvre - {quantity} {unit} {description}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Tarif de main-d'\u0153uvre approuv\xE9 avec succ\xE8s",
  LABOR_RATE_CHANGE_SUBMITTED: "Modification du tarif de main-d\u2019\u0153uvre soumise",
  LABOR_RATE_CHANGES_WITH_COUNT: "Modifications du tarifs de main-d\u2019\u0153uvre ({count})",
  LABOR_RATE_CONFIRM: "Le tarif demand\xE9 est inf\xE9rieur au tarif actuel. \xCAtes-vous s\xFBr de vouloir soumettre la demande?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "Les taux en rouge indiquent une augmentation de plus de 10 % par rapport au taux existant",
  LABOR_RATE_HISTORY: "Historique des tarifs de main-d\u2019\u0153uvre",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Tarif de main-d\u2019\u0153uvre refus\xE9",
  LABOR_RATE_REQUESTS_STATUS: "Statut des demandes de taux de travail",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Taux de main-d'oeuvre renvoy\xE9 avec succ\xE8s",
  LABOR_RATES: "Tarifs de main-d\u2019\u0153uvre",
  LABOR_STATS: "Statistiques de main-d\u2019\u0153uvre",
  LABOR_TOTAL: "Main-d\u2019\u0153uvre totale",
  LABOR_TYPE: "Type de main-d\u2019\u0153uvre",
  LABOR_VALUE: "Valeur de la main d\u2019\u0153uvre",
  LABOR_WITH_COUNT: "Main d\u2019\u0153uvre ({count})",
  LANGUAGE: "Langue",
  LAST_LOCATION_FROM: "Dernier emplacement \xE0 partir de",
  LAST_NAME: "Nom",
  LAST_NAME_IS_REQUIRED: "Nom est obligatoire",
  LAST_PERSONAL_CONTACT: "Dernier contact personnel",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "D\xE9tails de l'Agence de Police",
  LAYOUT_CREATED_SUCCESSFULLY: "Mise en page cr\xE9\xE9e avec succ\xE8s",
  LAYOUT_DELETED_SUCCESSFULLY: "Mise en page supprim\xE9e avec succ\xE8s",
  LAYOUT_NAME: "Nom de la mise en page",
  LAYOUT_UPDATED_SUCCESSFULLY: "Mise en page mise \xE0 jour avec succ\xE8s",
  LEAD_ACCOUNT: "Compte principal",
  LEAD_DEALER: "Concessionnaire principal",
  LESS_THAN: "Moins de",
  LESS_THAN_OR_EQUALS: "Inf\xE9rieur(e) ou \xE9gal(e) \xE0",
  LICENSE_PLATE_NUMBER: "Num\xE9ro de plaque d'immatriculation",
  LIFETIME: "Garantie \xE0 vie",
  LINE_ITEMS_EXPORT: "Exportation d'\xE9l\xE9ments de campagne",
  LIST: "Liste",
  LIST_TOTAL: "Total liste",
  LOCATION: "Localisation",
  LOCATION_DUE: "Localisation est Obligatoire",
  LOCATIONS: "Localisations",
  LOCATIONS_WITH_COUNT: "Localisations ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "Machine d\xE9j\xE0 enregistr\xE9e \xE0 ce client",
  MACHINE_INFORMATION: "Information de la machine",
  MACHINE_MODEL_TYPE: "Mod\xE8le/type de machine",
  MACHINE_MODEL_TYPE_REQUIRED: "Mod\xE8le/type de machine requis",
  MACHINE_STATUS: "Statut de la machine",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Mise \xE0 jour du statut de la machine approuv\xE9e",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Document de mise \xE0 jour du statut de la machine",
  MACHINE_STATUS_UPDATE_REJECTED: "Mise \xE0 jour du statut de la machine refus\xE9e",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Mises \xE0 jour du statut de de la machine ({count})",
  MACHINE_TYPE: "Type de Machine",
  MACHINE_TYPE_IS_REQUIRED: "Type de Machine est obligatoire",
  MACHINE_USE: "Usage de la machine",
  MAILING_RECIPIENT: "Destinataire du publipostage (pr\xE9nom et nom)",
  MAILING_RECIPIENT_REQUIRED: "Destinataire de publipostage requis",
  MAINTENANCE: "Maintenance",
  MAINTENANCE_PLAN: "Programmes d\u2019entretien",
  MAINTENANCE_PLAN_INFO: "Information sur le programme d\u2019entretien",
  MARK_AS_REVIEW: "Marquer comme r\xE9vis\xE9",
  MARKETING_INCENTIVE: "Marketing - Motivation",
  MARKETING_JD_PROMISE: "Marketing - Promesse JD",
  MARKETING_MAINTENANCE_PLAN: "Marketing - Programme d\u2019entretien",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Marketing - Vente en masse, Suivi",
  MARKETING_MASS_CHANNEL_PDI: "Marketing - Vente en masse, PDI",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Client de vente en masse -suivi",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Rappel: veuillez contacter votre conseiller juridique pour les proc\xE9dures de \"Ne Pas Appeler\"  au sein de votre region  ou au niveau f\xE9d\xE9ral avant de faire un appel de suivi apr\xE8s vente.",
  MASS_CHANNEL_PDI_CLAIM: "Vente en gros - PDI",
  MASTER_WARRANTY_TYPE: "Type de garantie principale",
  MATERIAL: "Num\xE9ro de mat\xE9riau",
  MERCHANDISE: "Marchandise",
  MESSAGE: "Message",
  MESSAGES: "Messages",
  METHOD_OF_CONTACT: "M\xE9thode de contact",
  METHOD_OF_CONTACT_IS_REQUIRED: "Le champ M\xE9thode de contact est obligatoire",
  METRIC: "Indicateur de p\xE9nalit\xE9",
  METRICS: "Indicateurs de p\xE9nalit\xE9",
  MILEAGE_LIMIT: "Limite de kilom\xE9trage",
  MOBILE_PHONE: "T\xE9l\xE9phone mobile",
  MODEL: "Mod\xE8le",
  MODEL_NUMBER: "Num\xE9ro de mod\xE8le",
  MODIFIED: "Modifi\xE9(e)",
  MONTH_TO_DATE: "Mois \xE0 ce jour",
  MORE: "Plus",
  MULTIPLE: "multiple",
  NAME: "Nom",
  NET: "Net",
  NET_AMOUNT: "Montant net",
  NET_AMOUNT_PAID: "Montant net pay\xE9",
  NET_TOTAL: "Total net",
  NEW: "Nouvelle",
  NEW_ACCOUNT: "Nouveau compte",
  NEW_CLAIM: "Nouvelle demande de garantie",
  NEW_CLAIM_VALUE: "Nouvelle valeur de demande",
  NEW_CUSTOMER_REQUIRED: "Nouveau Cient obligatoire",
  NEW_DEALER: "Nouveau concessionnaire",
  NEW_DEALER_DISTANCE: "Nouvelle distance de revendeur",
  NEW_DEALER_LOCATION: "Localisation du nouveau concessionnaire",
  NEW_LABOR_RATE: "Nouvel  tarif de main-d\u2019\u0153uvre",
  NEW_REQUEST_ENTER_RATES: "Nouvelle demande - Entrer les taux",
  NEW_STATUS: "Nouveau statut",
  NEW_TRANSFER: "Nouveau transfert",
  NEW_TRANSFER_CREATED: "Nouveau transfert cr\xE9\xE9",
  NEW_VALUE: "Nouvelle valeur",
  NO: "Non",
  NO_ACTIVE_WARRANTY: "Pas de garantie active",
  NO_AFFECTED_PINS: "Aucun NIP sous la responsabilit\xE9 de votre concession n'est affect\xE9",
  NO_AUTHORITY_TO_ACCESS: "Vous n'avez pas le droit d'acc\xE9der au JDWS. Les utilisateurs de la fonction de concessionnaire s'il vous pla\xEEt faire un suivi aupr\xE8s de votre administrateur de profil (DPA) pour v\xE9rifier l'autorit\xE9 et les utilisateurs de Deere contacter le support avec une copie de cette erreur ici",
  NO_CLAIMS: "Il n\u2019y a aucune demande de garantie",
  NO_CUSTOMER_ASSOCIATED: "Aucun(e) client(e) n\u2019est associ\xE9(e)",
  NO_CUSTOMER_SELECTED: "Pas de client(e) s\xE9lectionn\xE9(e)",
  NO_DEALER_INVOICES: "Aucune facture de concessionnaire",
  NO_DEALERS_MAPPED: "Aucun concessionnaire n\u2019est associ\xE9 \xE0 votre identifiant. Contactez l\u2019administrateur du syst\xE8me.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "Non (fournir une preuve par photo)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "Aucune information disponible pour ce produit",
  NO_LOWERCASE: "Non",
  NO_MATCHING_DEALERS: "Aucun concessionnaire ne correspond au triage de text.",
  NO_OPEN_PART_REQUESTS: "Aucune demande de pi\xE8ce ouverte",
  NO_OPEN_PIPS: "Aucun  Programme (PIP) ouvert",
  NO_PARTS_RETURNED: "Aucune Pi\xE8ce Retourn\xE9e",
  NO_PIP_PRODUCTS: "Aucun produit du programme (PIP)",
  NO_PRODUCT_FOUND: "Aucun produit trouv\xE9",
  NO_REQUIRED_ITEMS: "Il n'y a pas d'articles obligatoires",
  NO_RESULTS: "Aucun r\xE9sultat",
  NO_RESULTS_FOUND: "Aucun r\xE9sultat trouv\xE9",
  NO_ROWS_TO_SHOW: "Pas de rang\xE9es \xE0 afficher",
  NO_SPECIAL_INSTRUCTIONS: "Il n\u2019y a pas d' instructions sp\xE9ciales",
  NO_TRAVEL: "Pas de d\xE9placement",
  NON_RECOVERABLE_TAXES: "Taxes non r\xE9cup\xE9rables",
  NON_TRACKED_PINS_HELP_TEXT: "Certains produits n\u2019apparaissent dans la garantie qu\u2019apr\xE8s l\u2019enregistrement. Votre recherche correspond \xE0 une gamme de ces produits.",
  NON_TRAVEL: "Pas de d\xE9placement",
  NONE: "Aucun",
  NORMAL: "NORMALE",
  NOT_EQUAL: "In\xE9gal",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Notification ajout\xE9e avec succ\xE8s",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Notification supprim\xE9e avec succ\xE8s",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "S\xE9quence de notification mise \xE0 jour avec succ\xE8s",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Notification mise \xE0 jour avec succ\xE8s",
  NOTIFICATIONS: "Notifications",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Nombre d\u2019occurrences de diagnostic",
  NUMBER_OF_OPEN_PIPS: "{number} programmes d\u2019am\xE9lioration (PIP) actifs",
  NUMBER_OF_REPAIR_OCCURRENCES: "Nombre d\u2019occurrences de r\xE9paration",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "Nombre d\u2019occurrences de remplacement",
  OLD_LABOR_RATE: "Ancien tarif de main-d\u2019\u0153uvre",
  ON_SHELF: "Stockage",
  ON_SHELF_COST: "Co\xFBts de stockage",
  ONE_ITEM_MUST_BE_SELECTED: "Un \xE9l\xE9ment doit \xEAtre s\xE9lectionn\xE9",
  OPEN: "Ouvrir",
  OPEN_PART_REQUESTS: "Demandes en retour de pi\xE8ces actives",
  OPEN_PART_REQUESTS_WITH_COUNT: "Demandes en retour de pi\xE8ces actives ({count})",
  OPEN_PIP_COUNT: "Nombre de PIP ouverts",
  OPEN_PIP_PROGRAMS: "Registre de Programme",
  OPEN_PIPS: "Programmes (PIP) actifs",
  OPEN_PIPS_REPORT: "Rapport du Programme d'Amelioration Non Accompli",
  OPEN_PIPS_TAB: "Ouvrir les PIP ({count})",
  OPERATORS_COMPLAINT: "Quelle \xE9tait la plainte de l\u2019op\xE9rateur?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "R\xE9clamation de l\u2019op\xE9rateur requise",
  OPERATORS_MANUAL_NUMBER: "Num\xE9ro du manuel de l'op\xE9rateur",
  OPTION_CODE: "Code d'option",
  OPTION_CODE_CREATED_SUCCESSFULLY: "Code d'option cr\xE9\xE9 avec succ\xE8s",
  OPTION_CODE_DELETED_SUCCESSFULLY: "Codes d'option supprim\xE9 avec succ\xE8s",
  OPTION_CODES: "Codes d'option",
  OR: "ou",
  ORIGINAL_CLAIM_VALUE: "Valeur de la r\xE9clamation d'origine",
  ORIGINAL_SUBMISSION_DATE: "Date originale de soumission",
  ORIGINALLY_SUBMITTED: "Initialement soumis(e)",
  OTHER: "Autre",
  OTHER_AMOUNT_OF_USE: "Autre Nombre d\u2019Usage",
  OTHER_AMOUNT_OF_USE_REQUIRED: "Autre Nombre d\u2019Usage est obligatoire",
  OTHER_CREDIT: "Autres Cr\xE9dits",
  OTHER_CREDIT_1: "Autres Cr\xE9dits 1",
  OTHER_CREDIT_2: "Autres Cr\xE9dits 2",
  OTHER_CREDIT_3: "Autres Cr\xE9dits 3",
  OTHER_CREDIT_ADJUSTMENT: "Ajustement d'autres cr\xE9dits",
  OTHER_CREDIT_ITEM_DETAILS: "Autres Cr\xE9dits - {description} ({quantity} {unit})",
  OTHER_CREDIT_TOTAL: "Total d'autre cr\xE9dit",
  OTHER_CREDITS: "Autres Cr\xE9dits",
  OTHER_CREDITS_WITH_COUNT: "Autres cr\xE9dits ({count})",
  OTHER_INSTRUCTIONS: "Autres instructions",
  OUTPUT_PIN: "NIP de production",
  OVERDUE: "En retard",
  OVERRIDE_ACCOUNT: "Remplacer le compte",
  OVERRIDE_EFFECTIVE_DATE: "Substituer la date d'entr\xE9e en vigueur",
  OVERRIDE_SUGGESTED_ACCOUNT: "Passage en mode manuel forc\xE9 du compte sugg\xE9r\xE9",
  OWNERSHIP_STATUS: "Statut de la propri\xE9t\xE9",
  OWNERSHIP_STATUS_IS_REQUIRED: "Statut de Propri\xE9t\xE9 est obligatoire",
  PART: "Pi\xE8ce",
  PART_1: "Pi\xE8ce 1",
  PART_2: "Pi\xE8ce 2",
  PART_3: "Pi\xE8ce 3",
  PART_4: "Pi\xE8ce 4",
  PART_5: "Pi\xE8ce 5",
  PART_6: "Pi\xE8ce 6",
  PART_7: "Pi\xE8ce 7",
  PART_8: "Pi\xE8ce 8",
  PART_9: "Pi\xE8ce 9",
  PART_10: "Pi\xE8ce 10",
  PART_AMONT_OF_USE: "Dur\xE9e d\u2019utilisation de pi\xE8ce",
  PART_FAMILY: "Famille de pi\xE8ces",
  PART_ITEM_DETAILS: "Pi\xE8ces - {quantity} {description} N\xB0 de pi\xE8ce {partNumber}",
  PART_NUMBER: "Num\xE9ro de pi\xE8ce",
  PART_REQUEST: "Demande de retour de pi\xE8ce",
  PART_REQUEST_NUMBER: "Demande de retour de pi\xE8ce {rgaNumber}",
  PART_REQUEST_STATUS: "Statut de la demande de retour de pi\xE8ce",
  PART_REQUESTS: "Demandes de retour de pi\xE8ce",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Saisir le num\xE9ro de la demande de garantie, 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "La recherche de demande de garantie doit contenir 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "La recherche de num\xE9ro de cas DTAC doit contenir le num\xE9ro complet du cas DTAC, 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Saisir le num\xE9ro complet du cas DTAC",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "La recherche de num\xE9ro de Pi\xE8ce doit contenir 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Saisir le num\xE9ro de piece, 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "La recherche de num\xE9ro de demande de retour de pi\xE8ce doit contenir 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Saisir le num\xE9ro de pi\xE8ce demand\xE9e en retourd, 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "La recherche de NIP doit contenir 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Saisir le NIP, 4 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "La recherche de l'ordre de travail doit contenir l\u2019ordre complet, 2 caract\xE8res au minimum",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Saisir l'ordre de reparation complet",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Demande de retour de pi\xE8ce mise \xE0 jour avec succ\xE8s",
  PART_RETURN: "Pi\xE8ce retourn\xE9e",
  PART_RETURNS: "Pi\xE8ces retourn\xE9es",
  PART_SERIAL_NUMBER: "Num\xE9ro de s\xE9rie de la pi\xE8ce",
  PART_SERIAL_NUMBER_IS_REQUIRED: "Num\xE9ro de s\xE9rie de la Pi\xE8ce est obligatoire",
  PART_TOTAL: "Total de pi\xE8ce",
  PART_TYPE: "Type de pi\xE8ce",
  PART_USE: "Nombre d'usage de pi\xE8ce",
  PART_VALUE: "Valeur de la pi\xE8ce",
  PARTIAL_DEBIT: "D\xE9bit partiel",
  PARTICIPANT: "Participant",
  PARTS: "Pi\xE8ces",
  PARTS_ADDITIVE: "Additif de pi\xE8ces",
  PARTS_ADJUSTMENT: "R\xE9glage des pi\xE8ces",
  PARTS_COVERAGE_SEARCH: "Recherche sur la couverture des pi\xE8ces",
  PARTS_TEMPLATE: "Gabarit des pi\xE8ces",
  PARTS_USE: "Nombre d'usage de pi\xE8ces",
  PARTS_USE_IS_REQUIRED: "Utilisation des pi\xE8ces est obligatoire",
  PARTS_WITH_COUNT: "Pi\xE8ces ({count})",
  PARTS_WITH_PARENTHESES: "Pi\xE8ce(s)",
  PAST_DUE: "En retard",
  PAYER_ACCOUNT: "Compte payeur",
  PERCENT_COMPLETE: "Pourcentage achev\xE9",
  PERCENTAGE: "Pourcentage",
  PERCENTAGE_DEBIT: "Pourcentage de d\xE9bit",
  PERCENTAGE_SYMBOL: "{percentage}%",
  PERCENTAGE_TO_DEBIT: "Pourcentage de d\xE9bit",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "Dans le cas d\u2019une machine d\xE9finitivement HS, veuillez joindre une photo de la machine permettant de confirmer qu\u2019elle ne pourra plus jamais \xEAtre remise \xE0 neuf, r\xE9par\xE9e ou r\xE9utilis\xE9e. Les machines d\xE9finitivement HS ne peuvent faire l\u2019objet d\u2019aucun PIP.",
  PERSON_RESPONSIBLE: "La personne responsable",
  PHONE: "T\xE9l\xE9phone",
  PHONE_REQUIRED: "T\xE9l\xE9phone requis",
  PICTURE: "Image",
  PICTURE_REQUEST: "Demande d'image",
  PICTURE_REQUEST_STATUS: "Statut de la demande d'image",
  PICTURE_REQUEST_STATUS_ERROR: "Les pi\xE8ces jointes sont pr\xEAtes \xE0 \xEAtre soumises avec cette demande.",
  PIN: "NIP",
  PIN_CREATED_SUCCESSFULLY: "NIP cr\xE9\xE9 avec succ\xE8s",
  PIN_CROSS_REFERENCE: "R\xE9f\xE9rence crois\xE9e de NIP",
  PIN_INVALID: "NIP invalide",
  PIN_IS_REQUIRED: "NIP est Obligatoire",
  PIN_REQUIRED: "NIP obligatoire",
  PIN_SEARCH: "Recherche de broches",
  PIN_SEARCH_INFORMATION: "Informations de recherche de broches",
  PIN_TRANSFER_INFORMATION: "Informations sur le transfert de broches",
  PINS: "NIPs",
  PINS_NOT_REGISTERED: "NIPs non enregistr\xE9s",
  PIP: "Programme (PIP)",
  PIP_CODE: "Code PIP",
  PIP_CODE_CREATED_SUCCESSFULLY: "Demande de code PIP cr\xE9\xE9e avec succ\xE8s",
  PIP_CODE_REQUEST: "Demande de code du programme (PIP)",
  PIP_CODE_REQUEST_APPROVED: "Demande de code du programme (PIP) approuv\xE9e",
  PIP_CODE_REQUEST_REJECTED: "Demande de code du programme (PIP) refus\xE9e",
  PIP_CODE_REQUESTS_WITH_COUNT: "Demandes de code du programme (PIP) ({count})",
  PIP_COMPLETION_STATUS: "Statut des programmes effectu\xE9s",
  PIP_DETAILS: "D\xE9tails du programme (PIP)",
  PIP_HISTORY: "Historique du programme (PIP)",
  PIP_ID: "N\xB0 du programme (PIP)",
  PIP_NUMBER: "Num\xE9ro de programme (PIP)",
  PIP_PROGRAM: "Programme PIP",
  PIP_PROGRAM_IS_REQUIRED: "Programme PIP est obligatoire",
  PIP_PROGRAMS: "Programmes PIP",
  PIP_SEARCH: "Recherche du programme",
  PIP_STATUS: "Statut du programme (PIP)",
  PIP_TYPE: "Type de Programme (PIP)",
  PIP_TYPES: "Types de Programme (PIP)",
  PIPS: "Programmes (PIP)",
  PIPS_UNPAID_LABOR_ADDITIVE: "Additif impay\xE9 sur la main-d\u2019\u0153uvre des programmes (PIP)",
  PLAN_DESCRIPTION: "Description du plan",
  PLAN_END_DATE: "Date de fin du plan",
  PLAN_ENDS: "Fin du plan",
  PLAN_NAME: "Nom du plan",
  PLAN_NAME_IS_REQUIRED: "Nom du plan est obligatoire",
  PLAN_NAMES: "Noms du plan",
  PLAN_START_DATE: "Date de d\xE9but du plan",
  PLAN_STARTS: "D\xE9but du plan",
  PLANNED_BY: "Pr\xE9vu(e)",
  PLANT: "Usine",
  PLATE_REQUEST_INFORMATION: "Informations sur la demande de plaque",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "Veuillez s\xE9lectionner un compte principal",
  PLEASE_SELECT_CLAIM_TYPE: "Veuillez s\xE9lectionner le type de demande de garantie",
  POLISH: "Polonais",
  PORTUGUESE: "Portugais",
  POSTAGE_DELIVERY_DATE: "Date de livraison du courrier",
  POSTAL_CODE: "Code postal",
  POSTAL_CODE_REQUIRED: "Code postal requis",
  POSTAL_TRACKING_NUMBER: "Num\xE9ro de suivi postal",
  POTENTIAL_RESPONSIBLE_DEALER: "Vendeur responsable potentiel",
  PRE_DELIVERY_INSPECTION: "Inspection avant livraison",
  PREFERRED_THEME: "Th\xE8me pr\xE9f\xE9r\xE9",
  PREPARE_AUDIT: "Pr\xE9parer audit",
  PREPARED: "Pr\xE9par\xE9(e)",
  PREPARING_AUDIT_FOR_WITH_DEALER: "Pr\xE9paration d\u2019audit pour {dealer}",
  PREVIOUS_AMOUNT_OF_USE: "Dur\xE9e d\u2019Utilisation pr\xE9c\xE9dent",
  PREVIOUS_INVOICE_NUMBER: "Num\xE9ro de facture pr\xE9c\xE9dente",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "Num\xE9ro de facture pr\xE9c\xE9dente est obligatoire",
  PREVIOUS_MONTH: "Mois pr\xE9c\xE9dent",
  PRICE: "Prix",
  PRICING_SUMMARY: "R\xE9sum\xE9 des prix",
  PRIMARY_ACTION: "Action principale",
  PRIMARY_LANGUAGE: "Langue principale",
  PRINT: "Imprimer",
  PRINT_CLAIM: "Imprimer la demande de garantie",
  PRINT_REGISTRATION_FORM: "Imprimer le Formulaire d'inscription",
  PRINT_REGISTRATION_FORM_MESSAGE: "Produit enregistr\xE9 au premier propri\xE9taire. Voulez-vous imprimer le formulaire d'inscription maintenant?",
  PRINT_TO_PDF: "Imprimez PDF",
  PRIORITY: "Priorit\xE9",
  PRNT_CLM: "Afficher la demande de garantie",
  PROCESS_DATE: "Date de traitement",
  PROCESSED: "Trait\xE9(e)",
  PROCESSED_PART_REQUESTS: "Demandes de pi\xE8ces trait\xE9es",
  PROCESSING_STATUS: "Statut de traitement",
  PROCESSING_STATUS_DESCRIPTION: "Description du statut de traitement",
  PRODUCT_DETAILS: "D\xE9tails des produits",
  PRODUCT_HIERARCHY: "Hi\xE9rarchie des produits",
  PRODUCT_INFORMATION: "Information du produit",
  PRODUCT_REGISTERED: "Produit enregistr\xE9",
  PRODUCT_REGISTRATION: "Enregistrement de produit",
  PRODUCT_REGISTRATION_PENDED: "L 'enregistrement du produit est suspendu",
  PRODUCT_TRACKING: "Suivi du produit",
  PRODUCTS: "Produits",
  PRODUCTS_BY_CUSTOMER: "Produits par client",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "Les codes PIN historiques peuvent \xEAtre manquants dans les r\xE9sultats de recherche en raison d'un probl\xE8me de connectivit\xE9 syst\xE8me temporaire.",
  PRODUCTS_WITH_COUNT: "Produits ({count})",
  PROGRAM: "Programme",
  PROGRAM_DESCRIPTION: "Description du programme",
  PROGRAM_IS_REQUIRED: "Le nom du programme est requis.",
  PROGRAM_NAME: "Nom du programme",
  PROGRAM_NAME_IS_REQUIRED: "Le nom du programme est requis.",
  PROGRAM_NUMBER: "Num\xE9ro de programme",
  PRT: "Suivi de produit",
  PRTS: "Suivi de produit",
  PURCHASE_INFO: "Informations sur l\u2019achat",
  PURCHASE_ORDER: "Bon de commande",
  PURCHASE_ORDER_IS_REQUIRED: "Bon de commande est obligatoire",
  PURCHASER_TYPE: "Type d'acheteur",
  PURCHASER_TYPE_REQUIRED: "Type d\u2019acheteur obligatoire",
  PUSH_XML: "R\xE9envoyer XML",
  QTY: "Qt\xE9",
  QUALIFY_FOR_EMISSIONS: "Qualifi\xE9(e) pour les antipollutions",
  QUANTITY: "Quantit\xE9",
  QUANTITY_1: "Quantit\xE9 1",
  QUANTITY_2: "Quantit\xE9 2",
  QUANTITY_3: "Quantit\xE9 3",
  QUANTITY_4: "Quantit\xE9 4",
  QUANTITY_5: "Quantit\xE9 5",
  QUANTITY_6: "Quantit\xE9 6",
  QUANTITY_7: "Quantit\xE9 7",
  QUANTITY_8: "Quantit\xE9 8",
  QUANTITY_9: "Quantit\xE9 9",
  QUANTITY_10: "Quantit\xE9 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "La requ\xEAte doit contenir au moins 3 caract\xE8res",
  QUEST_DESC: "Description douteuse",
  QUESTIONABLE_PART: "Pi\xE8ce Douteuse",
  QUEUED: "En file d'attente",
  REASON_FOR_CHANGE: "Raison du changement",
  REASON_FOR_DEBIT: "Raison du d\xE9bit",
  REASON_FOR_MISSING_PLATE: "Raison de la plaque manquante",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Raison de l'absence de plaque requise",
  REASON_FOR_OVERRIDE: "Raison de la substitution",
  REASON_FOR_REFUSAL: "Raison du refus",
  REASON_FOR_RETURN: "Raison du retour",
  REASON_FOR_RETURN_IS_REQUIRED: "Raison du retour est obligatoire",
  REASON_FOR_TRANSFER: "Raison du transfert",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "La raison du  transfert doit contenir des caract\xE8res alphanum\xE9riques",
  RECIPIENT_DEALER_OR_TCSM: "Destinataire (concessionnaire ou TCSM/MRSC)",
  RECIPIENT_MAILING: "Destinataire du publipostage",
  RECONCILE: "R\xE9concilier",
  RECONCILE_CLAIM: "Reconcilier la demande de garantie",
  RECONCILED: "R\xE9concili\xE9(e)",
  RECORD_AUDIT: "Enregistrer l\u2019audit",
  RECORD_AUDIT_FOR: "Enregistrer l\u2019audit pour {dealer}",
  RECORDS_FOUND: "{countToDisplay} {count, plural, one {document trouv\xE9} other {documents trouv\xE9s}}",
  RECOVERABLE_TAXES: "Taxes r\xE9cup\xE9rables",
  RECOVERED: "R\xE9cup\xE9r\xE9(e)",
  RECOVERED_WITH_MISSED_ADDITIVES: "R\xE9cup\xE9r\xE9(e) avec des additifs manqu\xE9s",
  RECOVERED_WITHOUT_ADDITIVES: "R\xE9cup\xE9r\xE9(e) sans additifs",
  RECOVERY: "R\xE9cup\xE9ration",
  RED_MUST_BE_LESS_THAN_YELLOW: "La valeur de l\u2019indicateur rouge doit \xEAtre inf\xE9rieure \xE0 celle de l\u2019indicateur jaune.",
  REFERENCE_1: "R\xE9f\xE9rence 1",
  REFERENCE_2: "R\xE9f\xE9rence 2",
  REFERENCE_INFORMATION: "Informations de r\xE9f\xE9rence",
  REFERENCE_NUMBER1: "Num\xE9ro de r\xE9f\xE9rence 1",
  REFERENCE_NUMBER2: "Num\xE9ro de r\xE9f\xE9rence 2",
  REGION: "R\xE9gion",
  REGISTER: "Enregistrer",
  REGISTER_A_PRODUCT_BY_PIN: "Enregistrer un produit par NIP",
  REGISTER_A_PRODUCT_TO_ADD: "Enregistrer le produit \xE0 ajouter au syst\xE8me de garantie",
  REGISTER_ANOTHER_PRODUCT: "Enregistrer un autre produit",
  REGISTER_PRODUCT: "Enregistrer le produit",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Enregistrer le produit et enregistrer un autre",
  REGISTERED: "Enregistr\xE9(e)",
  REGISTRATION: "Enregistrement",
  REGISTRATION_DATE: "Date d'enregistrement",
  REGISTRATION_DATES: "Dates d\u2019enregistrement",
  REGISTRATION_FORM: "Formulaire d\u2019enregistrement",
  REGISTRATION_HISTORY: "Historique d'enregistrement",
  REGISTRATION_NOT_ALLOWED: "Enregistrement non autoris\xE9 pour ce produit",
  REGISTRATION_REVIEW: "R\xE9vision de l'enregistrement",
  REGISTRATION_REVIEW_TAB: "R\xE9vision de l'enregistrement ({count})",
  REGISTRATION_STATUS: "Statut de l'enregistrement",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "Le statut d'enregistrement ne peut pas \xEAtre Nouveau",
  REGISTRATION_STATUS_REQUIRED: "Statut de l\u2019enregistrement requis",
  REGISTRATION_SUCCESS: "Enregistrement r\xE9ussi",
  REGISTRATION_TYPE: "Type d\u2019enregistrement",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Le type d\u2019enregistrement ne peut pas \xEAtre Nouveau",
  REGISTRATION_TYPE_REQUIRED: "Type d\u2019enregistrement obligatoire",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Enregistrement mis \xE0 jour avec succ\xE8s",
  REGISTRATIONS_REVIEW: "R\xE9vision des enregistrements",
  REIMBURSED: "Rembours\xE9(e)",
  REIMBURSED_AMOUNT: "Montant rembours\xE9",
  REIMBURSED_PERCENTAGE: "Pourcentage rembours\xE9",
  REIMBURSED_PERCENTAGE_INDICATOR: "Indicateur de pourcentage rembours\xE9",
  REIMBURSEMENT_DETAILS: "D\xE9tails de remboursement",
  REIMBURSEMENT_PERCENTAGE: "Pourcentage de remboursement",
  REIMBURSEMENT_SUMMARY: "R\xE9capitulatif des remboursements",
  REJECT: "Rejeter",
  REJECT_LABOR_RATE: "Refuser le tarif de main d\u2019\u0153uvre",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Refuser la demande d\u2019allocation commerciale",
  REJECTED: "Rejet\xE9(e)",
  REJECTED_APPEAL: "Appel rejet\xE9",
  RELATIONSHIP: "Relation",
  RELATIONSHIP_IS_REQUIRED: "Relation est obligatoire",
  REMOVE_FILTER: "Supprimer le filtre",
  REMOVE_FROM_AUDIT: "Supprimer de l\u2019audit",
  REMOVE_LAYOUT: "Supprimer la mise en page",
  RENTAL_PINS: "NIP de location",
  REPAIR_DATE: "Date de r\xE9paration",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "La date de r\xE9paration ne peut pas \xEAtre avant la date de panne",
  REPAIR_NUMBER: "Num\xE9ro de r\xE9paration",
  REPAIR_NUMBER_IS_REQUIRED: "Num\xE9ro de r\xE9paration est obligatoire",
  REPAIR_REPLACE_INDICATOR: "Indicateur de r\xE9paration/remplacement",
  REPAIRED: "R\xE9par\xE9(e)",
  REPAIRED_DATE: "Date de r\xE9paration",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "La date de r\xE9paration ne peut pas \xEAtre avant  la date de panne",
  REPAIRED_DATE_IS_REQUIRED: "Date de r\xE9paration est obligatoire",
  REPORT_DATE: "Date du rapport",
  REPORT_NUMBER: "Num\xE9ro du rapport",
  REPORTS: "Rapports",
  REQ_ADDL: "Modifier le cr\xE9dit",
  REQUEST_DATE: "Date de la requ\xEAte",
  REQUEST_DETAIL: "D\xE9tails de la demande",
  REQUEST_DUPLICATE_PIN_PLATE: "Demander la copie de la plaque NIP",
  REQUEST_FORM: "Formulaire de requ\xEAte",
  REQUEST_PIP_CODE: "Demander le code du programme (PIP)",
  REQUEST_STATUS: "Statut de la demande",
  REQUEST_SUBMITTED: "Requ\xEAte soumise",
  REQUEST_TYPE: "Type de demande",
  REQUEST_UPDATED_SUCCESSFULLY: "Demande mise \xE0 jour avec succ\xE8s",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Faire une requ\xEAte de d\xE9bit de la demande de garantie",
  REQUESTED: "Reclam\xE9(e)",
  REQUESTED_BY: "Requ\xEAte fait par",
  REQUESTED_DATE: "Date de requ\xEAte",
  REQUESTED_DATES: "Dates de requ\xEAte",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Montant de diagnostic souhait\xE9e",
  REQUESTED_DIAGNOSTIC_HOURS: "Heures de diagnostic souhait\xE9es",
  REQUESTED_LABOR_AMOUNT: "Montant de main-d\u2019\u0153uvre demand\xE9",
  REQUESTED_LABOR_HOURS: "Heures de main-d\u2019\u0153uvre demand\xE9es",
  REQUESTED_OTHER_CREDITS: "Autres cr\xE9dits demand\xE9s",
  REQUESTED_PARTS: "Pi\xE8ces demand\xE9es",
  REQUESTED_REPAIR_AMOUNT: "Montant de r\xE9paration souhait\xE9e",
  REQUESTED_REPAIR_HOURS: "Heures de r\xE9paration souhait\xE9es",
  REQUESTED_TRAVEL_TOTAL: "Total de d\xE9placement demand\xE9",
  REQUESTER_TCSM: "Demandeur (TCSM/MRSC)",
  REQUESTER_TCSM_REQUIRED: "Demandeur (TCSM/MRSC) requis",
  REQUIRED: "Obligatoire",
  REQUIRED_CRITERIA: "Crit\xE8res obligatoires",
  REQUIRED_ITEMS: "Articles obligatoires",
  RESEND_XML: "R\xE9envoyer XML",
  RESET: "R\xE9initialiser",
  RESPONDENT_INFORMATION: "Informations sur le repondant",
  RESPONSIBILITY_OF: "Responsabilit\xE9 de",
  RESPONSIBLE_ACCOUNT: "Compte responsible",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "Compte responsable obligatoire",
  RESPONSIBLE_DEALER: "Concessionnaire responsable",
  RET: "Retour",
  RETAIL_INSTALL: "Vente au d\xE9tail/installation",
  RETAIL_INSTALL_DATE: "Date de vente au d\xE9tail/installation",
  RETAIL_INSTALL_IS_REQUIRED: "Vente au d\xE9tail/installation est obligatoire",
  RETAILER_NAME: "Nom de distributeur",
  RETAILER_NAME_IS_REQUIRED: "Nom du distributeur est obligatoire",
  RETRY: "R\xE9essayer",
  RETURN: "Retour",
  RETURN_LABOR_RATE: "Taux de main-d'oeuvre de retour",
  RETURN_REQUEST: "Demande de retour",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "Retourner la demande de garantie d\u2019allocation commerciale",
  RETURN_STATUS: "Statut de de retour",
  RETURNED: "Retourn\xE9(e)",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "La date de retour ne peut pas \xEAtre avant la date de livraison",
  RETURNED_DATE_IS_REQUIRED: "Date de retour est obligatoire",
  REVIEW_DEALER_RECOMMENDATIONS: "Voulez-vous vraiment marquer l'\xE9pingle pour r\xE9vision ?",
  REVISE: "R\xE9viser",
  REVISED: "Revis\xE9(e)",
  ROLLING_12_CREDIT_AMOUNT: "\xC9tendu sur le montant de 12 cr\xE9dits",
  ROLLING_12_MONTHS: "\xC9tendu sur  12 mois",
  RUN_REPORT: "G\xE9n\xE9rer un rapport",
  RUSSIAN: "Russe",
  SAP_DOWN_WARNING: "La fonctionnalit\xE9 du syst\xE8me de garantie est endommag\xE9e. Nous travaillons \xE0 corriger cela le plus rapidement possible. Actualisez le navigateur pour v\xE9rifier la disponibilit\xE9 du syst\xE8me.",
  SAVE: "Sauvegarder",
  SAVE_AS_DRAFT: "Sauvegarder comme brouillon",
  SAVE_AS_NEW_LAYOUT: "Enregistrer la nouvelle mise en page",
  SAVE_AUDIT: "Sauvegarder l\u2019audit",
  SAVE_CHANGES: "Sauvegarder les modifications",
  SAVE_TO_VALIDATE: "Sauvegarder pour valider",
  SAVE_VALD: "Sauvegarder et valider",
  SAVE_VALIDATE: "Sauvegarder et valider",
  SEARCH: "Rechercher",
  SEARCH_BOX_PLACEHOLDER: "Saisir le NIP, num\xE9ro de s\xE9rie, num\xE9ro de demande de garantie, cas DTAC ou nom du client",
  SEARCH_BY_CLAIM_TYPE: "Saisir le type complet de demande de garantie",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "La recherche de la demande de garantie doit inclure le type complet de demande de garantie, de 4 \xE0 9 caract\xE8res",
  SEARCH_BY_FAILURE_PART_NUMBER: "Saisir la r\xE9f\xE9rence compl\xE8te de la pi\xE8ce en panne",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "La recherche de demande de garantie doit inclure la ref\xE9rence compl\xE8te de la pi\xE8ce en panne, 4 caract\xE8res au minimum",
  SEARCH_BY_WORK_ORDER: "Sasir l'Ordre de Reparation, 2 caract\xE8res au minimum",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "La recherche de l'Ordre de Reparation doit \xEAtre de 2 caract\xE8res au minimum.",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Saisir le num\xE9ro complet de la demande de garantie",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "La recherche de demande de garantie doit se faire par le num\xE9ro complet de la demande, de 4 \xE0 9 caract\xE8res",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Saisir le num\xE9ro de s\xE9rie complet du composant",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "La recherche de composant doit se faire par le num\xE9ro de s\xE9rie complet, 1 caract\xE8re au minimum",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Entrez le code confidentiel",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Saisir le num\xE9ro complet de mod\xE8le",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "La recherche de mod\xE8le doit se faire par le num\xE9ro complet de mod\xE8le, de 3 \xE0 12 caract\xE8res",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Saisir le NIP, 6 caract\xE8res au minimum",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "La recherche du NIP doit \xEAtre de 6 \xE0 17 caract\xE8res",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Saisir le num\xE9ro de programme (PIP, au moins 4 caract\xE8res)",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "La recherche du programme (PIP) doit \xEAtre de 4 \xE0 12 caract\xE8res",
  SEARCH_RESULTS_TAB: "R\xE9sultats de la recherche ({count})",
  SECOND_SHIP_TO_LOCATION: "Deuxi\xE8me Envoi sur site",
  SELECT: "S\xE9lectionner",
  SELECT_A_RANGE: "S\xE9lectionner un intervalle",
  SELECT_ALL: "S\xE9lectionner tout",
  SELECT_AUTO_SUBMIT: "S\xE9lectionner la soumission automatique",
  SELECT_BRANCH: "S\xE9lectionner la succursale",
  SELECT_CLAIM_TYPE: "S\xE9lectionner le type de demande de garantie",
  SELECT_CLAIMS: "S\xE9lectionner les demandes de garantie",
  SELECT_CLAIMS_WITHIN_DATE_RANGE: "S\xE9lectionner les demandes de garantie dans l\u2019intervalle de date",
  SELECT_COLUMNS: "S\xE9lectionner des colonnes",
  SELECT_COUNTRY: "Identifier le pays",
  SELECT_CSV_SEPARATOR: "S\xE9lectionner CSV s\xE9parateur",
  SELECT_DATE_FORMAT: "S\xE9lectionner le format de date",
  SELECT_DEALERS_AND_STATUS: "S\xE9lectionner les concessionnaires et le statut",
  SELECT_DECIMAL_FORMAT: "S\xE9lectionner le format d\xE9cimal",
  SELECT_DISPLAY_FORMAT: "S\xE9lectionner le format d\u2019affichage",
  SELECT_FACTORY: "S\xE9lectionner les param\xE8tres d\u2019usine",
  SELECT_LANGUAGE: "S\xE9lectionner la langue",
  SELECT_LAYOUT: "S\xE9lectionner Mise en Page",
  SELECT_NEW_CLAIMS: "S\xE9lectionner des nouvelles demandes de garantie",
  SELECT_PIP_CODE: "S\xE9lectionner le code du programme (PIP)",
  SELECT_PLAN_NAMES: "S\xE9lectionner les noms des plans",
  SELECT_SERVICE_INTERVAL_TYPES: "S\xE9lectionner les types d\u2019intervalles de service",
  SELECT_SORT_BY: "S\xE9lectionner Trier par",
  SELECT_SORT_DIRECTION: "S\xE9lectionner Direction de Tri",
  SELECT_STATE: "S\xE9lectionner la Region/Province",
  SELECT_STATUS: "S\xE9lectionner le statut",
  SELECT_TERRITORY: "S\xE9lectionner un territoire",
  SELECT_THEME: "S\xE9lectionner le th\xE8me",
  SELECT_TIME_ZONE: "S\xE9lectionner le fuseau horaire",
  SELECT_VALUES_TO_APPROVE: "S\xE9lectionner les valeurs \xE0 approuver",
  SELECTED_COLUMNS: "S\xE9lectionn\xE9 Colonnes",
  SELECTED_FOR_AUDIT: "S\xE9lectionn\xE9 pour l'audit",
  SELECTED_FOR_AUDIT_VSR: "Voir la solution DTAC 221475 pour la documentation d'audit requise et les pi\xE8ces jointes n\xE9cessaires pour cette demande",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "La s\xE9lection de plusieurs comptes et de types de garantie a une influence sur la performance",
  SEND: "Soumettre",
  SERIAL_NUMBER: "Num\xE9ro de S\xE9rie",
  SERIAL_NUMBER_INVOICE_NUMBER: "Num\xE9ro de S\xE9rie / Num\xE9ro de Facture",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "Le temps de r\xE9ponse du serveur est trop long et la requ\xEAte a \xE9t\xE9 annul\xE9e. Veuillez essayer une requ\xEAte plus sp\xE9cifique ou r\xE9essayer plus tard ult\xE9rieurement.",
  SERVICE_DATE_IS_REQUIRED: "Date de service est obligatoire",
  SERVICE_INTERVAL: "Intervalle d'entretien",
  SERVICE_INTERVAL_BEGIN_DATE: "Date de d\xE9but d'intervalle d'entretien",
  SERVICE_INTERVAL_END_DATE: "Date de fin d'intervalle d'entretien",
  SERVICE_INTERVAL_IS_REQUIRED: "Intervalle d\u2019entretien est obligatoire",
  SERVICE_INTERVAL_NUMBER: "Num\xE9ro d'intervalle d'entretien",
  SERVICE_INTERVAL_STATUS: "Statut d'intervalle d'entretien",
  SERVICE_INTERVAL_TYPE: "Type d'intervalle d'entretien",
  SERVICE_INTERVAL_TYPES: "Types d'intervalle d'entretien",
  SERVICE_PART: "Pi\xE8ce de service",
  SERVICE_UNAVAILABLE: "Entretien non disponible",
  SERVICED: "Entretenu(e)",
  SERVICED_DATE_IS_REQUIRED: "Date de r\xE9vision est requise.",
  SERVICED_IS_REQUIRED: "Le service est requis.",
  SET_AS_DEFAULT: "Enregistrer sous d\xE9faut",
  SETTINGS: "Mes param\xE8tres",
  SETTLED: "R\xE9solu(e)",
  SETTLEMENT_NO_REGISTRATION: "R\xE8glement, aucun enregistrement",
  SETUP: "Configuration",
  SETUP_DATE_IS_REQUIRED: "Date de configuration est obligatoire",
  SETUP_IS_REQUIRED: "Configuration obligatoire",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Envoyer \xE0",
  SHIPPED: "Exp\xE9di\xE9(e)",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "Informations d'exp\xE9dition/Instructions sp\xE9ciales",
  SHIPPING_INSTRUCTIONS: "Instructions d\u2019exp\xE9dition",
  SHORT_TEXT: "Texte court",
  SHORT_TEXT_IS_REQUIRED: "Un texte court est requis",
  SHOW_ALL: "Montre tout ({count})",
  SHOW_EXCLUDED: "Afficher les exclus",
  SHOW_MORE: "Montre plus",
  SHOW_MORE_GROUPS: "Afficher {countToDisplay} {count, plural, one {groupe suppl\xE9mentaire} other {groupes suppl\xE9mentaires}}",
  SHOW_RED_IF_LESS_THAN: "Afficher Rouge si inf\xE9rieur \xE0",
  SHOW_REIMBURSED_AMOUNT: "Afficher le montant rembours\xE9",
  SHOW_REIMBURSED_PERCENTAGE: "Afficher le pourcentage rembours\xE9",
  SHOW_YELLOW_IF_LESS_THAN: "Afficher Jaune si inf\xE9rieur \xE0",
  SIGN_IN_REQUIRED: "Connexion requise",
  SIGN_OUT: "D\xE9connexion",
  SKIP_AUDIT: "Ignorer l'audit",
  SKIP_AUDIT_SUCCESS: "L'audit a \xE9t\xE9 ignor\xE9 et la date d'\xE9ch\xE9ance est \xE0 venir.",
  SOME_PARTS_RETURNED: "Certaines pi\xE8ces Retourn\xE9es",
  SORT_BY: "Trier par",
  SPANISH: "Espagnol",
  SPECIAL_ALLOWANCE: "Allocation commerciale",
  SPECIAL_ALLOWANCE_CALCULATION: "Calcul d\u2019allocation commerciale",
  SPECIAL_ALLOWANCE_CLAIM: "Demande de garantie d\u2019allocation commerciale",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Statut de la demande de garantie d\u2019allocation commerciale",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Statut de la demande de garantie d\u2019allocation commerciale",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Statut de la demande de garantie d\u2019allocation commerciale mis \xE0 jour",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Demande de garantie d\u2019allocation commerciale - {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Demandes de garantie d\u2019allocation commerciale ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "Contributions \xE0 l\u2019allocation commerciale",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Description de l\u2019allocation commerciale",
  SPECIAL_ALLOWANCE_TYPE: "Type d'allocation Commerciale",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "Type d\u2019allocation commerciale est obligatoire",
  SPECIAL_INSTRUCTIONS: "Instructions Sp\xE9ciales",
  SPG: "SPG",
  SPGS: "SPG",
  STANDARD_VIEW: "Vue g\xE9n\xE9rale",
  START_AMOUNT_OF_USE: "Nombre d'usage au d\xE9but",
  STARTS: "D\xE9bute",
  STARTS_WITH: "D\xE9bute par",
  STATE: "R\xE9gion/Province",
  STATE_PROVINCE: "\xC9tat/province",
  STATE_PROVINCE_REQUIRED: "\xC9tat/province requis",
  STATUS: "Statut",
  STATUS_CHANGE_REQUEST: "Requ\xEAte de changement de statut",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Requ\xEAte de modification de statut cr\xE9\xE9e avec succ\xE8s",
  STATUS_FOR: "Statut pour {pin}",
  STATUS_INDICATOR: "Indicateur de statut",
  STATUS_REASON: "Raison de l'\xE9tat",
  STOLEN_DATE: "Date de vol",
  STORE: "Entrp\xF4t",
  STORE_IS_REQUIRED: "Entrp\xF4t est obligatoire",
  STORE_NUMBER_IS_REQUIRED: "Num\xE9ro de magasin est obligatoire",
  STREET_1: "Rue 1",
  STREET_2: "Rue 2",
  SUB: "Soumettre",
  SUB_CLAIM_TYPE: "Demande de garantie subsidiaire",
  SUB_TYPE: "Sous-type",
  SUBMISSION_DATE: "Date de soumission",
  SUBMIT: "Soumettre",
  SUBMIT_AUDIT: "Soumettre l\u2019audit",
  SUBMIT_AUDIT_FOR: "Soumettre l\u2019audit pour {dealer}",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Soumettre une demande de d\xE9bit total pour {claimNumber}",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Soumettre une demande de d\xE9bit partiel pour {claimNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "Soumettre une demande de d\xE9bit en pourcentage pour {claimNumber}",
  SUBMIT_REQUEST: "Soumettre la requ\xEAte",
  SUBMITTED: "Soumis(e)",
  SUBMITTED_AVAILABLE_TO_EDIT: "Soumis(e) (Modifiable)",
  SUCCESS: "Succ\xE8s",
  SUCCESS_MESSAGE_TITLE: "Une op\xE9ration a r\xE9ussi:",
  SUCCESS_MESSAGES_TITLE: "Plusieurs op\xE9rations ont r\xE9ussi:",
  SUPPLIER_WARRANTY: "Garantie du fournisseur",
  SURVEY_QUESTIONS: "Questions de sondage",
  SUSPENDED: "Suspendu(e)",
  SWEDISH: "Su\xE9dois",
  SYSTEM_SELECTED_CLAIMS: "Demandes s\xE9lectionn\xE9es par le syst\xE8me",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "Demandes s\xE9lectionn\xE9es par le syst\xE8me ({count})",
  TABM: "TABM",
  TAX: "Taxe",
  TCSM: "TCSM/MRSC",
  TECH_ID: "Identifiant du technicien",
  TERMINATED: "Termin\xE9(e)",
  TERMINATES: "Termine",
  TERRITORY: "Territoire",
  TEST: "Test",
  TEST_RESULTS_CODE: "Code des r\xE9sultats des test",
  THEME: "Th\xE8me",
  TIME_LIMIT: "Limite de temps",
  TIME_ZONE: "Fuseau horaire",
  TITLE: "Titre",
  TITLE_IS_REQUIRED: "Le titre est obligatoire",
  TO: "\xE0",
  TODAY: "Aujourd\u2019hui",
  TOO_MANY_RESULTS: "Votre demande a donn\xE9 trop de r\xE9sultats. Veuillez affiner vos termes de recherche et r\xE9essayer.",
  TOTAL: "Total",
  TOTAL_AMOUNT: "Montant total",
  TOTAL_APPROVED: "Total approuv\xE9",
  TOTAL_APPROVED_CLAIM_VALUE: "Valeur totale de la demande de garantie approuv\xE9e",
  TOTAL_APPROVED_INCLUDING_TAXES: "Total approuv\xE9 TTC",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Total approuv\xE9 sans additifs",
  TOTAL_CONTRIBUTION: "Contribution totale",
  TOTAL_REIMBURSED: "Total rembours\xE9",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Total rembours\xE9 ({currency})",
  TOTAL_REQUESTED: "Total reclam\xE9",
  TOTAL_REQUESTED_CLAIM_VALUE: "Valeur totale de la demande de garantie reclam\xE9e",
  TOTAL_UNPAID: "Total non pay\xE9",
  TRACKING_NUMBER: "Num\xE9ro de suivi",
  TRANSFER: "Transf\xE9rer",
  TRANSFER_APPROVALS: "Approbations de transfert",
  TRANSFER_APPROVALS_TAB: "Approbations de transfert ({count})",
  TRANSFER_CREATED: "Transfert cr\xE9\xE9",
  TRANSFER_DEALER_RECOMMENDATIONS: "\xCAtes-vous s\xFBr de vouloir transf\xE9rer la broche \xE0 un autre concessionnaire ?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Transfert mis \xE0 jour avec succ\xE8s",
  TRANSFERS: "Transferts",
  TRAVEL: "Frais de d\xE9placement",
  TURKISH: "Turc",
  TWO_PERCENT_WITHHOLD_VALUE: "2% de retenue",
  TYPE: "Type",
  TYPES: "Types",
  UNABLE_TO_CONTACT_THE_SERVER: "Impossible de contacter le serveur",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "Impossible de charger les donn\xE9es du client",
  UNDO: "Annuler",
  UNDO_REGISTRATION: "Annuler l'enregistrement",
  UNDO_REGISTRATION_SUCCESSFULL: "Annuler l'enregistrement r\xE9ussi",
  UNIT: "Unit\xE9",
  UNIT_1: "Unit\xE9 1",
  UNIT_2: "Unit\xE9 2",
  UNIT_3: "Unit\xE9 3",
  UNIT_OF_MEASURE: "Unit\xE9 de mesure",
  UNPAID_LABOR: "Main d'oeuvre non pay\xE9e",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Additifs de main-d\u2019\u0153uvre  non r\xE9mun\xE9r\xE9s - \xE0 l'exclusion des programmes d\u2019am\xE9lioration (PIP)",
  UNPAID_LABOR_ADDITIVES_PIPS: "Additifs de main-d\u2019\u0153uvre  non r\xE9mun\xE9r\xE9s \u2013 programmes d\u2019am\xE9lioration (PIP)",
  UNPAID_OTHER_CREDITS: "Autres Cr\xE9dits non r\xE9mun\xE9r\xE9s",
  UNPAID_PARTS: "Pi\xE8ces non r\xE9mun\xE9r\xE9s",
  UNPAID_PARTS_ADDITIVE: "Additif des pi\xE8ces non r\xE9mun\xE9r\xE9s",
  UNPAID_TRAVEL: "D\xE9placement non r\xE9mun\xE9r\xE9",
  UNSUB: "Modifier",
  UNSUBMIT_CLAIM: "Modifier Demande",
  UPDATE_CUSTOMER_INFORMATION: "Mettre \xE0 jour l'information du client",
  UPDATE_LABOR_RATES: "Mise \xE0 jour des taux de main-d\u2019\u0153uvre",
  UPDATE_LAYOUT: "Mettre \xE0 jour la disposition",
  UPDATE_MACHINE_STATUS: "Actualiser le statut de la machine",
  UPDATE_MACHINE_STATUS_HISTORY: "Actualiser l\u2019historique du statut de la machine",
  UPDATE_REGISTRATION: "Mettre \xE0 jour l'enregistrement",
  UPDATE_SELECTED: "Mettre \xE0 jour la s\xE9lection",
  UPDATED: "Mis \xE0 jour",
  UPDATED_BY: "Mis \xE0 jour par",
  UPLOAD_DOCUMENT: "T\xE9l\xE9charger le document",
  UPTIME_ASSURANCE: "Assurance de disponibilit\xE9",
  USEFUL_LINKS: "Liens utiles",
  USER: "utilisateur",
  USER_PREFERENCES_UPDATED: "Mise \xE0 jour des pr\xE9f\xE9rences de l\u2019utilisateur",
  USER_SELECTED: "Utilisateur s\xE9lectionn\xE9",
  USER_SELECTED_CLAIMS_WITH_COUNT: "Demandes de garantie s\xE9lectionn\xE9es par l\u2019utilisateur ({count})",
  USERS_INFORMATION: "Informations sur les utilisateurs",
  VALIDATE: "Valider",
  VALIDATE_CLAIM: "Valider la demande de garantie",
  VALUE: "Valeur",
  VALUE_OF_REPAIR: "Valeur de la r\xE9paration",
  VIEW_CLAIM: "Afficher la demande de garantie",
  VIEW_DETAILS: "Afficher les d\xE9tails",
  VIEW_OPEN_PIPS: "Afficher les Programmes (PIP) ouverts",
  VIEW_PIP: "Afficher le Programme (PIP)",
  VIEW_PRODUCTS: "Afficher les produits",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "Afficher les produits et les informations de mise \xE0 jour",
  VIEW_UPDATE: "Afficher/mettre \xE0 jour",
  VSR_MESSAGES: "Messages VSR",
  WAITING_FOR_DLR_INV: "En attente de la facture du concessionnaire",
  WAITING_FOR_INVOICE: "En attente de la facture ({count})",
  WAITING_SINCE: "En attente depuis",
  WARNING_MESSAGE_TITLE: "Un avertissement a \xE9t\xE9 envoy\xE9:",
  WARNING_MESSAGES: "Messages d\u2019avertissement",
  WARNING_MESSAGES_TITLE: "Plusieurs avertissements ont \xE9t\xE9 envoy\xE9s:",
  WARRANTY: "Garantie",
  WARRANTY_ADMIN: "Garantie Administrateur",
  WARRANTY_CLAIM_TYPE: "Type de demande \xE0 titre de garantie",
  WARRANTY_COVERAGE: "Couverture de la garantie",
  WARRANTY_EXPIRATION: "Expiration de la garantie",
  WARRANTY_TYPE: "Type de garantie",
  WARRANTY_TYPES: "Types de garanties",
  WEAR_PARTS: "Porter des pi\xE8ces",
  WEAR_PARTS_COVERAGE: "Couverture des pi\xE8ces de rechange",
  WELCOME: "Bienvenue",
  WIP: "Travail en cours",
  WITH_ADDITIVES: "Avec additifs",
  WITNESS_FIRST_NAME: "Pr\xE9nom du t\xE9moin",
  WITNESS_LAST_NAME: "Nom de famille du t\xE9moin",
  WORK_ORDER: "Ordre de r\xE9paration",
  WORK_ORDER_NUMBER: "Num\xE9ro d'Ordre de r\xE9paration",
  WORK_ORDER_ONE: "Ordre de r\xE9paration 1",
  WORK_ORDER_ONE_IS_REQUIRED: "L'ordre de r\xE9paration est obligatoire",
  WORK_ORDER_THREE: "Ordre de r\xE9paration 3",
  WORK_ORDER_THREE_IS_REQUIRED: "L'ordre de r\xE9paration 3 est obligatoire",
  WORK_ORDER_TWO: "Ordre de r\xE9paration 2",
  WORK_REPAIR_ORDER: "Ordre de r\xE9paration",
  YES: "Oui",
  YES_LOWERCASE: "Oui"
});